import React, {useState} from "react";
import { Container, Table, Pagination } from "react-bootstrap";
import { BtnBorrarDinamico, BtnBoostrapDinamico } from "../Botones";
import { ModalDinamico } from "../Modals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { DeleteEmpresa } from "../../Api/Empresas.Api";
import { useDispatch } from "react-redux";
import { FormEditEmpresa } from "../Forms_Edit";
import { findName } from "../../globalFunctions";

export const TablaEmpresas = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const PAGE_SIZE = 10;
  const [currentPage, setCurrentPage] = useState(1);
  
 const indexOfLastItem = currentPage * PAGE_SIZE;
 const indexOfFirstItem = indexOfLastItem - PAGE_SIZE;
 const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

 const paginate = (pageNumber) => setCurrentPage(pageNumber);
  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "800px",
        overflowY: "auto",
        marginTop: "20px",
      }}
    >
      <Table>
        <thead>
          <tr
            style={{
              backgroundColor: "#fed8",
              fontStyle: "italic",
              fontWeight: "bold",
              fontSize: ".8rem",
            }}
          >
            <td>Nombre</td>
            <td>Detalle</td>
            <td>Editar</td>
            <td>Borrar</td>
          </tr>
        </thead>
        <tbody>
          {currentData.map((e) => (
            <tr key={e.em_iden}>
              <td>{findName(data, "em_iden", e.em_iden, "em_name")}</td>
              <td>
                <BtnBoostrapDinamico
                  size={"sm"}
                  name={<FontAwesomeIcon icon={faEye} />}
                  click={() => navigate(`/Empresa/${e.em_iden}/Plantas`)}
                />
              </td>
              <td>
                <ModalDinamico
                  size={"sm"}
                  variant={"outline-success"}
                  Body={<FormEditEmpresa id={e.em_iden} />}
                  Titulo="Editar Empresa"
                  nameBoton={<FontAwesomeIcon size="xs" icon={faPenToSquare} />}
                />
              </td>
              <td>
                <BtnBorrarDinamico
                  action={() => dispatch(DeleteEmpresa(e.em_iden))}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination style={{ display: "flex", flexWrap: "wrap" }}>
        {Array.from({ length: Math.ceil(data.length / PAGE_SIZE) }).map(
          (item, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          )
        )}
      </Pagination>
    </Container>
  );
};
